import { Regions } from './constants';

/**
 * gets the region code corresponding to the given country code
 * @param {string} countryCode
 * @returns {string} - region code
 */
export var getRegion = function getRegion(countryCode) {
  return Regions[countryCode.toUpperCase()] || 'US';
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/GeolocationUtils/index.js
// module id = 1359
// module chunks = 11